// ===== 일주(日柱) 기반 성격/운세 해석 — 60갑자 완전판 =====

export interface DayPillarInterpretation {
  stem: string;
  branch: string;
  title: string;
  summary: string;
  personality: string[];
  strengths: string[];
  weaknesses: string[];
  career: string[];
  relationship: string;
  wealth: string;
  health: string;
  advice: string;
}

const INTERPRETATIONS: Record<string, DayPillarInterpretation> = {
  // ────── 甲(갑) 일간 ──────
  '甲子': {
    stem:'甲', branch:'子',
    title:'배양목(培養木) — 겉은 강하고 속은 따뜻한',
    summary:'큰 나무가 물을 품은 기운. 겉으로는 당당하고 의리 있어 보이지만 속으로는 섬세하고 배려심이 깊어요.',
    personality:['의리 있고 믿음직한 성격','겉은 강하지만 속은 여림','리더십 있으나 혼자 있을 때 외로움을 느낌'],
    strengths:['한 번 맡은 일은 끝까지 책임져요','주변 사람들을 잘 챙겨줘요','위기 상황에서 침착함을 유지해요'],
    weaknesses:['고집이 세고 융통성이 부족할 수 있어요','속마음을 잘 드러내지 않아 오해를 받을 수 있어요','완벽주의로 스트레스를 받아요'],
    career:['관리직·리더직','의료·교육·상담','대기업·공무원'],
    relationship:'배려심 깊은 파트너를 만나면 행복해요. 속마음을 잘 표현하는 연습이 필요해요.',
    wealth:'안정적인 수입을 선호해요. 투자보다는 저축이 잘 맞는 궁합이에요.',
    health:'간과 신장에 주의하세요. 스트레스를 건강한 방식으로 풀어야 해요.',
    advice:'가끔은 약한 모습을 보여도 괜찮아요. 주변 사람들은 이미 당신을 믿고 있어요.',
  },
  '甲寅': {
    stem:'甲', branch:'寅',
    title:'입록목(入祿木) — 끝없이 성장하는 대나무',
    summary:'봄의 기운을 가득 품은 나무. 끊임없이 성장하고 발전하려는 의지가 강해요.',
    personality:['적극적이고 도전적인 성격','학습·성장에 대한 욕구가 강함','남보다 한 발 앞서 움직이려 함'],
    strengths:['새로운 것을 빨리 배워요','위기를 기회로 바꾸는 능력','끈기와 인내심이 강해요'],
    weaknesses:['조급함으로 인해 실수할 수 있어요','남과 비교하며 스트레스를 받아요','한 우물을 파야 하는데 여러 갈래로 퍼질 수 있어요'],
    career:['창업·스타트업','교육·코칭·강사','기획·마케팅·영업'],
    relationship:'함께 성장할 수 있는 파트너가 최고예요. 너무 의존적인 관계는 답답하게 느껴질 수 있어요.',
    wealth:'수입이 늘어나는 속도가 빨라요. 하지만 쓰는 속도도 빠르니 저축 습관을 들이세요.',
    health:'목과 어깨·관절에 신경 쓰세요. 운전할 때 특히 주의하세요.',
    advice:'성장은 마라톤이에요. 잠시 쉬어가도 괜찮아요. 지금 이 순간도 충분히 잘하고 있어요.',
  },
  '甲辰': {
    stem:'甲', branch:'辰',
    title:'용목(龍木) — 구름 위로 뻗어나가는 기세',
    summary:'용의 등에 선 나무처럼 큰 뜻을 품고 있어요. 이상이 높고 현실을 뛰어넘으려는 기질이 강해요.',
    personality:['이상이 높고 큰 꿈을 품은 성격','인내력과 지구력이 강함','외모와 체면을 중시함'],
    strengths:['장기적 목표를 포기하지 않아요','조직력과 추진력이 뛰어나요','포용력이 크고 리더십이 있어요'],
    weaknesses:['현실과 이상 사이에서 갈등해요','고집이 세어 충돌이 생길 수 있어요','쉽게 자만할 수 있어요'],
    career:['행정·기획·정치','건설·부동산·개발','대기업 임원·공공기관'],
    relationship:'자신을 인정해주는 파트너가 필요해요. 상대를 압도하지 않도록 주의하세요.',
    wealth:'큰 사업보다는 꾸준한 재테크가 더 잘 맞아요.',
    health:'소화기와 피부에 신경 쓰세요.',
    advice:'큰 그림을 그리는 것도 좋지만, 발밑의 한 걸음도 소중히 하세요.',
  },
  '甲午': {
    stem:'甲', branch:'午',
    title:'봉목(鳳木) — 태양을 향해 곧게 자라는 나무',
    summary:'나무가 태양을 향해 쭉 뻗는 모습. 진취적이고 열정이 넘치며 활발한 사교성을 가지고 있어요.',
    personality:['밝고 긍정적인 에너지','열정적이고 표현력이 풍부함','인정욕구가 강하고 경쟁심도 있음'],
    strengths:['추진력과 행동력이 뛰어나요','사람들에게 활력을 불어넣어요','아이디어가 풍부해요'],
    weaknesses:['충동적인 결정을 할 수 있어요','감정 기복이 있어요','중심을 잡는 시간이 필요해요'],
    career:['연예·방송·홍보','마케팅·영업·강사','스타트업·창업'],
    relationship:'밝고 에너지 넘치는 파트너와 잘 맞아요.',
    wealth:'큰 수익 기회를 잘 잡지만 과소비 주의가 필요해요.',
    health:'심장과 혈압, 시력에 주의하세요.',
    advice:'열정은 최고의 무기예요. 하지만 방향을 정하고 집중하는 것이 효율을 높여요.',
  },
  '甲申': {
    stem:'甲', branch:'申',
    title:'엄목(嚴木) — 도끼로 다듬어지는 원목',
    summary:'원목이 도끼질을 받아 쓸모 있게 다듬어지는 모습. 시련을 통해 더욱 단단해지는 기질이에요.',
    personality:['현실적이고 실용적인 성격','강인한 의지와 끈기','냉철한 판단력'],
    strengths:['어려움을 이겨내는 강인함','논리적이고 분석적인 사고','장기적 안목을 갖추고 있어요'],
    weaknesses:['날카로워 주변과 마찰이 생길 수 있어요','감정 표현이 서툴러요','독단적으로 결정하려 해요'],
    career:['IT·공학·제조업','법조·군·경찰','컨설팅·분석직'],
    relationship:'신뢰할 수 있는 파트너를 원해요. 감정 표현을 더 적극적으로 해보세요.',
    wealth:'실용적인 투자와 저축으로 꾸준히 재산을 쌓아요.',
    health:'호흡기와 대장에 주의하세요.',
    advice:'단단해진 것은 아름다운 거예요. 주변에 감사함도 함께 표현해보세요.',
  },
  '甲戌': {
    stem:'甲', branch:'戌',
    title:'고목(枯木) — 가을에 깊어지는 나무',
    summary:'가을날 깊이를 더해가는 나무의 기운. 신중하고 깊이 있는 성격으로 믿음직한 존재감이 있어요.',
    personality:['신중하고 깊이 있는 사고','의리와 책임감이 강함','보수적이지만 따뜻한 성격'],
    strengths:['신뢰감이 높고 의리 있어요','꾸준한 노력으로 성과를 내요','깊이 있는 인간관계를 맺어요'],
    weaknesses:['변화에 적응하는 데 시간이 걸려요','고집스럽게 느껴질 수 있어요','감정을 잘 드러내지 않아요'],
    career:['금융·보험·부동산','교육·연구직','공기업·안정적 조직'],
    relationship:'오랜 시간 함께하며 깊어지는 관계를 원해요.',
    wealth:'꾸준한 저축과 안전한 투자로 자산을 불려나가요.',
    health:'위장과 근골격계에 주의하세요.',
    advice:'당신의 깊이와 신뢰감은 소중한 자산이에요. 변화도 두려워하지 마세요.',
  },

  // ────── 乙(을) 일간 ──────
  '乙丑': {
    stem:'乙', branch:'丑',
    title:'전원초(田園草) — 겨울 땅에서 봄을 기다리는 풀',
    summary:'차가운 땅 속에서 봄을 기다리는 풀의 기운. 끈질긴 생명력과 인내심으로 결국 꽃을 피워요.',
    personality:['인내력이 강하고 끈기가 있음','내성적이지만 속이 단단함','현실적이고 실용적인 성향'],
    strengths:['어떤 상황도 버텨내는 생명력','꾸준함으로 결국 결과를 만들어요','절약과 저축에 능해요'],
    weaknesses:['너무 참다가 한꺼번에 폭발할 수 있어요','변화나 도전을 두려워해요','표현이 부족해 오해를 받을 수 있어요'],
    career:['농업·식품업·요식업','회계·금융·세무','공무원·안정적 직장'],
    relationship:'오래 알고 지낸 사람과 깊은 관계가 맺어져요.',
    wealth:'검소하게 모아 큰 재산을 이루는 타입이에요.',
    health:'소화기관과 면역력에 주의하세요.',
    advice:'기다림도 전략이에요. 당신의 시간이 반드시 올 거예요.',
  },
  '乙卯': {
    stem:'乙', branch:'卯',
    title:'덩굴목(藤木) — 유연하게 감아오르는 덩굴',
    summary:'덩굴처럼 주변 환경에 잘 적응하며 성장하는 기운. 유연하고 섬세하며 인간관계를 중요시해요.',
    personality:['섬세하고 배려심이 깊음','상황에 따라 유연하게 대처','예술적 감각이 뛰어남'],
    strengths:['사람들과의 관계를 잘 맺어요','위기 상황에서도 부드럽게 넘어가요','디테일을 잘 살리는 능력'],
    weaknesses:['우유부단하고 결정을 못 내릴 때가 있어요','남의 눈치를 너무 봐요','자존감이 낮아질 수 있어요'],
    career:['디자인·예술·문화 분야','상담·코디네이터','서비스업·접대직'],
    relationship:'든든한 파트너를 만나면 안정감을 느껴요. 너무 맞추려 하지 말고 자신의 의견도 표현하세요.',
    wealth:'꾸준히 모으는 게 중요해요. 큰 투자보다는 소소한 재테크가 잘 맞아요.',
    health:'소화기관과 피부에 주의하세요. 스트레스는 피부로 나타나요.',
    advice:'당신의 유연함은 강점이에요. 하지만 때로는 단호하게 선을 그어야 해요.',
  },
  '乙巳': {
    stem:'乙', branch:'巳',
    title:'화중초(火中草) — 불 옆에서 빛을 발하는 풀',
    summary:'불꽃 곁에서 빛을 받아 아름답게 빛나는 풀의 기운. 총명하고 번뜩이는 재치가 있어요.',
    personality:['영리하고 총명한 두뇌','말재주가 있고 사교적임','변화를 즐기고 호기심이 왕성함'],
    strengths:['빠른 상황 판단력','언어 능력과 설득력이 뛰어나요','새로운 분야를 쉽게 익혀요'],
    weaknesses:['한 곳에 집중하기 어려워요','변덕스럽고 끈기가 약할 수 있어요','말이 앞서고 실행이 늦을 수 있어요'],
    career:['방송·미디어·작가','교육·강사·컨설팅','IT·마케팅'],
    relationship:'지적으로 통하는 파트너가 최고예요.',
    wealth:'아이디어와 재치로 돈을 버는 능력이 있어요.',
    health:'심장과 눈, 신경계에 주의하세요.',
    advice:'아이디어를 실행으로 옮기는 힘을 길러보세요.',
  },
  '乙未': {
    stem:'乙', branch:'未',
    title:'원야초(原野草) — 넓은 들판을 자유롭게 덮는 풀',
    summary:'광활한 들판에 자라는 풀처럼 포용력이 넓고 자유로운 정신을 지니고 있어요.',
    personality:['포용력이 넓고 자유로운 성격','예술적·감성적 기질','따뜻하고 친화적임'],
    strengths:['예술적 감수성이 뛰어나요','주변 분위기를 부드럽게 만들어요','인내심과 배려심이 깊어요'],
    weaknesses:['결단력이 부족할 수 있어요','자기 주장이 약해 이용당할 수 있어요','감성적 기복이 있어요'],
    career:['예술·음악·패션','교육·봉사·복지','서비스업·관광'],
    relationship:'따뜻하고 자유로운 관계를 원해요.',
    wealth:'안정적 수입보다 감성적 만족을 위해 쓰는 경향이 있어요.',
    health:'소화기와 관절에 주의하세요.',
    advice:'넓은 마음이 당신의 가장 큰 매력이에요.',
  },
  '乙酉': {
    stem:'乙', branch:'酉',
    title:'금상초(金上草) — 보석함 위의 꽃',
    summary:'화려한 보석 위에 놓인 꽃처럼 세련되고 아름다운 기운. 미적 감각이 뛰어나고 완벽을 추구해요.',
    personality:['미적 감각이 뛰어나고 세련됨','섬세하고 예민한 감수성','완벽주의 성향'],
    strengths:['예술적 재능이 탁월해요','꼼꼼하고 정확한 업무 처리','독특한 매력으로 주목을 받아요'],
    weaknesses:['너무 예민해 쉽게 상처받아요','비판에 약하고 자존심이 강해요','현실보다 이상에 집착할 수 있어요'],
    career:['패션·미용·디자인','예술·음악·영상','세무·회계·법무'],
    relationship:'취향이 맞는 세련된 파트너를 원해요.',
    wealth:'전문 분야의 재능으로 안정적 수입을 만들어요.',
    health:'폐와 호흡기, 피부에 주의하세요.',
    advice:'완벽하지 않아도 당신은 이미 충분히 아름다워요.',
  },
  '乙亥': {
    stem:'乙', branch:'亥',
    title:'수초(水草) — 물속에서 유유히 자라는 수초',
    summary:'물속에서 유연하게 흔들리면서도 뿌리를 단단히 내린 수초의 기운. 직관력이 강하고 깊은 감성을 지녀요.',
    personality:['직관력이 강하고 감수성이 풍부함','신비로운 매력과 깊은 내면','자유롭고 개방적인 성격'],
    strengths:['사람의 감정을 빠르게 읽어요','창의력과 상상력이 뛰어나요','어떤 환경에서도 적응해요'],
    weaknesses:['감정 기복이 심할 수 있어요','현실 감각이 부족할 때가 있어요','경계심이 약해 이용당할 수 있어요'],
    career:['예술·문학·심리'],
    relationship:'깊은 감정 교류가 가능한 파트너를 원해요.',
    wealth:'감성적 소비 습관을 조절하면 재산이 쌓여요.',
    health:'신장과 면역력에 주의하세요.',
    advice:'깊은 감수성을 예술로 승화시키면 빛날 수 있어요.',
  },

  // ────── 丙(병) 일간 ──────
  '丙子': {
    stem:'丙', branch:'子',
    title:'빙상화(氷上火) — 얼음 위의 불꽃',
    summary:'차가운 겨울 한가운데 활활 타오르는 불꽃의 기운. 강인한 열정과 극단적인 기질이 공존해요.',
    personality:['강렬한 열정과 추진력','극단적 기질로 올인하는 성향','표현이 강하고 존재감이 뚜렷함'],
    strengths:['어떤 상황도 돌파하는 에너지','사람들에게 열정을 전파해요','도전 정신이 누구보다 강해요'],
    weaknesses:['충동적이고 극단적인 선택을 해요','지속성이 부족할 수 있어요','감정 기복이 크고 소진되기 쉬워요'],
    career:['영업·마케팅·방송','스포츠·퍼포먼스','창업·스타트업'],
    relationship:'열정적인 사람에게 매력을 느끼지만 감정 기복으로 관계가 불안정할 수 있어요.',
    wealth:'수입은 크지만 충동 지출을 조심해야 해요.',
    health:'신장과 심장 균형에 주의하세요.',
    advice:'뜨거운 열정 뒤에는 꼭 쉬어가는 시간이 필요해요.',
  },
  '丙寅': {
    stem:'丙', branch:'寅',
    title:'욱일화(旭日火) — 새벽을 깨우는 태양',
    summary:'새벽 하늘을 붉게 물들이는 태양의 기운. 밝고 활동적이며 시작을 좋아하는 개척자 기질이에요.',
    personality:['활기차고 긍정적인 에너지','개척자 기질과 리더십','행동이 말보다 먼저 나옴'],
    strengths:['선구자적 기질로 새 길을 열어요','밝은 에너지로 주변에 활력을 줘요','결단력과 추진력이 강해요'],
    weaknesses:['계획 없이 돌진하는 경향','끝마무리가 약할 수 있어요','인내심이 부족할 수 있어요'],
    career:['창업·사업가','스포츠·체육계','탐험·개척 직종'],
    relationship:'에너지가 잘 맞는 파트너와 환상의 호흡을 맞춰요.',
    wealth:'빠르게 벌고 빠르게 투자하는 스타일이에요.',
    health:'근육과 간에 주의하세요.',
    advice:'첫 번째 발걸음만큼 마지막 발걸음도 중요해요.',
  },
  '丙辰': {
    stem:'丙', branch:'辰',
    title:'운중화(雲中火) — 구름 사이를 뚫는 햇살',
    summary:'구름을 뚫고 나오는 햇살처럼 어려움도 극복하는 기운. 창의적이고 신비로운 매력이 있어요.',
    personality:['창의적이고 상상력이 풍부함','신비로운 분위기와 깊은 내면','감성과 이성이 공존함'],
    strengths:['창의적 문제 해결 능력','남다른 통찰력이 있어요','어떤 장벽도 돌파하는 의지'],
    weaknesses:['몽상적이어서 현실과 괴리가 생겨요','결정에 시간이 오래 걸려요','인내심이 필요한 상황에서 힘들어해요'],
    career:['연구·개발·기획','예술·철학','IT·디자인'],
    relationship:'지적으로 대화가 통하는 파트너를 원해요.',
    wealth:'아이디어를 사업화하면 큰 수익이 생겨요.',
    health:'소화기와 피부에 주의하세요.',
    advice:'빛은 어둠이 있어야 더 빛나요. 과정을 즐기세요.',
  },
  '丙午': {
    stem:'丙', branch:'午',
    title:'로화(祿火) — 뜨겁게 타오르는 태양',
    summary:'한낮의 태양처럼 뜨겁고 밝은 기운. 에너지가 넘치고 주변을 밝게 만드는 매력이 있어요.',
    personality:['밝고 긍정적인 에너지','리더십과 추진력이 강함','표현력이 뛰어나고 매력적'],
    strengths:['어디서든 주목받는 존재감','어려운 상황에서도 희망을 잃지 않음','사람들을 이끄는 카리스마'],
    weaknesses:['성급하고 충동적인 결정을 해요','자존심이 강해 인정하기 어려워요','에너지가 너무 강해 주변을 압도해요'],
    career:['연예·방송·공연','영업·마케팅·홍보','CEO·임원·정치'],
    relationship:'같이 있으면 즐거운 파트너가 좋아요. 너무 얌전한 사람은 답답하게 느껴질 수 있어요.',
    wealth:'큰돈을 벌 수도 잃을 수도 있어요. 전문가의 조언을 받으세요.',
    health:'심장과 혈압에 주의하세요.',
    advice:'당신의 열정은 소중해요. 하지만 가끔은 불을 낮추고 주변을 살펴보세요.',
  },
  '丙申': {
    stem:'丙', branch:'申',
    title:'투영화(透映火) — 금속 위에 투영되는 햇빛',
    summary:'햇빛이 금속 표면에 반사되어 더욱 강하게 빛나는 기운. 분석력과 열정이 결합된 독특한 기질이에요.',
    personality:['분석력과 열정이 공존함','날카로운 통찰력','행동력과 실행력이 강함'],
    strengths:['논리적이면서도 열정적이에요','목표를 향해 체계적으로 움직여요','어떤 분야든 빨리 습득해요'],
    weaknesses:['너무 직설적이어서 상처를 줄 수 있어요','완벽주의로 스스로를 몰아붙여요','유연성이 부족할 수 있어요'],
    career:['IT·공학·분석직','금융·투자·트레이딩','방송 기술·연출'],
    relationship:'지적이고 실용적인 파트너를 원해요.',
    wealth:'분석 기반의 투자로 안정적인 수익을 만들어요.',
    health:'호흡기와 심장에 주의하세요.',
    advice:'이성과 열정의 균형이 당신의 강점이에요.',
  },
  '丙戌': {
    stem:'丙', branch:'戌',
    title:'석중화(石中火) — 바위 속에 숨은 불씨',
    summary:'바위 속에 잠재된 불씨처럼 겉으로는 조용하지만 내면에 강한 열정이 숨어있어요.',
    personality:['겉은 차분하지만 속은 뜨거운 열정','의리가 강하고 신뢰감이 높음','한 번 마음먹으면 끝까지 가는 성격'],
    strengths:['믿음직하고 꾸준한 추진력','어떤 상황도 버텨내는 강인함','깊고 오래가는 관계를 맺어요'],
    weaknesses:['감정 표현이 서툴러 오해를 받아요','변화에 저항하는 경향이 있어요','고집이 세어 충돌이 생길 수 있어요'],
    career:['군·경찰·공무원','건설·부동산·제조업','연구·개발직'],
    relationship:'한번 사랑하면 끝까지 헌신하는 타입이에요.',
    wealth:'꾸준히 모아서 단단한 자산을 쌓아요.',
    health:'위장과 관절, 피부에 주의하세요.',
    advice:'당신의 열정은 불꽃이 아니라 영원히 꺼지지 않는 잔불 같아요.',
  },

  // ────── 丁(정) 일간 ──────
  '丁丑': {
    stem:'丁', branch:'丑',
    title:'동화(凍火) — 겨울땅에 켜진 작은 불',
    summary:'추운 겨울 얼어붙은 땅 위의 작은 촛불처럼 어두운 곳을 밝히는 기운. 강한 의지와 헌신적인 성품이에요.',
    personality:['헌신적이고 책임감이 강함','참을성이 강하고 꾸준한 노력가','내면에 단단한 의지를 품고 있음'],
    strengths:['어떤 역경도 이겨내는 의지력','주변을 따뜻하게 돌봐요','신뢰받는 사람이 돼요'],
    weaknesses:['자신을 너무 희생하는 경향','표현이 부족해 오해를 받아요','변화를 거부할 수 있어요'],
    career:['의료·복지·봉사','교육·상담직','공무원·안정 직종'],
    relationship:'오래가는 안정적인 관계를 원해요.',
    wealth:'꾸준한 저축으로 안정적인 자산을 만들어요.',
    health:'혈액순환과 소화기에 주의하세요.',
    advice:'자신을 위한 시간도 소중히 하세요.',
  },
  '丁卯': {
    stem:'丁', branch:'卯',
    title:'문화(文火) — 봄날의 온기',
    summary:'봄날 따사로운 온기처럼 주변을 녹이는 기운. 감수성이 풍부하고 예술적 재능이 빛나요.',
    personality:['감수성이 풍부하고 예술적임','따뜻하고 친근한 성격','내면의 불꽃이 창의력으로 표출됨'],
    strengths:['예술·글쓰기 재능이 뛰어나요','사람의 마음을 따뜻하게 해요','세심하고 배려가 깊어요'],
    weaknesses:['감정에 치우치기 쉬워요','결단력이 부족할 수 있어요','쉽게 상처받는 편이에요'],
    career:['예술·문학·음악','디자인·공예','상담·교육'],
    relationship:'감성적으로 깊이 통하는 파트너를 원해요.',
    wealth:'예술적 재능을 사업화하면 큰 수익이 나요.',
    health:'목과 눈에 주의하세요.',
    advice:'당신의 섬세함이 세상을 아름답게 만들어요.',
  },
  '丁巳': {
    stem:'丁', branch:'巳',
    title:'문곡화(文曲火) — 지혜의 불꽃',
    summary:'총명한 불꽃이 지혜를 밝히는 기운. 영리하고 학문적 능력이 뛰어나며 깊은 사색을 즐겨요.',
    personality:['총명하고 지적 탐구심이 강함','냉철하고 분석적인 사고','독특한 개성과 카리스마'],
    strengths:['학문적·전문적 능력이 탁월해요','문제의 본질을 꿰뚫어보는 통찰','논리적이고 체계적인 사고'],
    weaknesses:['자존심이 강해 융통성이 부족해요','감정 표현이 약해요','완벽주의로 남을 판단할 수 있어요'],
    career:['연구·학계·전문직','법조·의료','IT·데이터 분석'],
    relationship:'지적 수준이 맞는 파트너와 깊은 관계를 맺어요.',
    wealth:'전문 지식을 활용한 수입이 가장 잘 맞아요.',
    health:'심장과 신경계에 주의하세요.',
    advice:'지식과 지혜는 다르다는 것을 기억하세요.',
  },
  '丁未': {
    stem:'丁', branch:'未',
    title:'예화(藝火) — 여름 석양의 붉은 노을',
    summary:'여름 저녁 하늘을 물들이는 노을처럼 아름답고 감성적인 기운. 예술적 감수성이 빛나요.',
    personality:['예술적이고 감성적인 성품','따뜻하고 배려심이 깊음','심미적 안목이 뛰어남'],
    strengths:['뛰어난 예술적 감각','사람을 따뜻하게 품어주는 능력','섬세한 관찰력'],
    weaknesses:['우유부단할 수 있어요','감정 기복이 있어요','비판에 민감해요'],
    career:['예술·디자인·공예','교육·상담','요리·플로리스트'],
    relationship:'감성이 풍부한 따뜻한 파트너를 원해요.',
    wealth:'예술성을 직업으로 연결하면 안정적인 수입이 생겨요.',
    health:'소화기와 혈액순환에 주의하세요.',
    advice:'당신의 예술적 감성은 세상에 따뜻함을 줘요.',
  },
  '丁酉': {
    stem:'丁', branch:'酉',
    title:'장생화(長生火) — 은은하게 빛나는 촛불',
    summary:'촛불처럼 은은하고 따뜻한 기운. 겉으로는 조용해도 속은 뜨겁고 열정적이에요.',
    personality:['섬세하고 예민한 감수성','속으로는 열정적이지만 겉은 차분','완벽주의자 성향'],
    strengths:['디테일과 정밀함의 대가','한 분야를 깊이 파는 능력','신뢰할 수 있는 조력자'],
    weaknesses:['너무 예민해 쉽게 상처받아요','자신을 너무 몰아세워요','표현을 아껴 오해를 살 수 있어요'],
    career:['연구·개발·전문직','디자인·예술·작곡','회계·세무·법무'],
    relationship:'세심하게 배려해주는 파트너가 좋아요.',
    wealth:'꾸준히 모으면 부자가 될 수 있어요.',
    health:'눈과 심장, 혈액순환에 주의하세요.',
    advice:'완벽할 필요는 없어요. 지금의 당신도 충분히 빛나고 있어요.',
  },
  '丁亥': {
    stem:'丁', branch:'亥',
    title:'수중화(水中火) — 물속의 불씨',
    summary:'물속에서도 꺼지지 않는 불씨처럼 어떤 어려움도 이겨내는 강인한 내면의 소유자예요.',
    personality:['강한 내면과 불굴의 의지','직관력이 강하고 신비로운 매력','감성적이지만 쉽게 꺾이지 않음'],
    strengths:['어떤 역경도 견디는 강인함','깊은 직관력과 통찰','독특한 매력으로 사람을 끌어요'],
    weaknesses:['감정을 억누르다가 폭발할 수 있어요','고독을 즐기지만 때로 외로워요','타협을 어려워할 수 있어요'],
    career:['심리·상담·치유','예술·문학','연구·탐구직'],
    relationship:'깊은 영적 교감을 원해요.',
    wealth:'안정적 직업을 토대로 천천히 재산을 쌓아요.',
    health:'신장과 심장에 주의하세요.',
    advice:'물속에서도 꺼지지 않는 당신의 불꽃은 기적이에요.',
  },

  // ────── 戊(무) 일간 ──────
  '戊子': {
    stem:'戊', branch:'子',
    title:'수산(水山) — 물을 품은 큰 산',
    summary:'물을 품고 있는 산처럼 든든하고 포용력이 있어요. 겉은 강하지만 내면은 부드럽고 지혜로워요.',
    personality:['든든하고 신뢰할 수 있는 성격','포용력이 크고 지혜로움','실용적이고 현실적임'],
    strengths:['어떤 상황도 버텨내는 안정감','포용력으로 주변을 편안하게 해요','현실적인 판단력이 뛰어나요'],
    weaknesses:['감정 표현이 서툴러요','변화를 두려워해요','융통성이 부족할 수 있어요'],
    career:['금융·은행·보험','부동산·건설','공무원·대기업'],
    relationship:'믿음직한 파트너를 만나면 평생 행복해요.',
    wealth:'부동산과 안전 자산 투자가 잘 맞아요.',
    health:'신장과 방광에 주의하세요.',
    advice:'당신의 든든함은 주변 사람들의 기둥이에요.',
  },
  '戊寅': {
    stem:'戊', branch:'寅',
    title:'산림(山林) — 숲을 품은 큰 산',
    summary:'울창한 숲을 품은 산처럼 풍성하고 생명력이 넘쳐요. 리더십과 포용력을 동시에 갖추고 있어요.',
    personality:['강인한 리더십과 포용력','실행력이 강하고 결단력 있음','책임감이 매우 강함'],
    strengths:['팀을 이끄는 리더십','어떤 도전도 정면 돌파해요','믿음직하고 의리 있어요'],
    weaknesses:['너무 강한 주장으로 충돌이 생겨요','타인의 의견을 무시할 수 있어요','휴식이 부족하면 번아웃이 와요'],
    career:['창업·대기업 임원','군·경찰·공공기관','스포츠·코치'],
    relationship:'함께 성장하는 파트너십을 원해요.',
    wealth:'사업 능력이 뛰어나 큰 재산을 만들 수 있어요.',
    health:'간과 근육에 주의하세요.',
    advice:'강함 속에 부드러움을 품으면 더 큰 리더가 돼요.',
  },
  '戊辰': {
    stem:'戊', branch:'辰',
    title:'대림토(大林土) — 든든한 큰 산',
    summary:'큰 산처럼 든든하고 안정적인 기운. 믿음직하고 책임감이 강해요.',
    personality:['신뢰할 수 있는 성격','실용적이고 현실적임','끈기와 인내심이 강함'],
    strengths:['한 번 맡은 일은 반드시 해내요','경제관념이 투철해요','위기 상황에서도 흔들리지 않아요'],
    weaknesses:['융통성이 부족하고 고집이 세요','변화를 두려워해요','표현이 서툴러 오해를 받을 수 있어요'],
    career:['부동산·건설·토목','금융·은행·보험','공무원·대기업'],
    relationship:'믿음직한 파트너를 만나면 평생 행복해요.',
    wealth:'부동산 운이 좋아요. 꾸준히 모으면 큰 자산을 만들 수 있어요.',
    health:'위장과 소화기관에 주의하세요.',
    advice:'당신의 든든함은 큰 장점이에요. 가끔은 유연하게 움직여보세요.',
  },
  '戊午': {
    stem:'戊', branch:'午',
    title:'열산(熱山) — 여름 태양에 달구어진 산',
    summary:'한여름 태양에 뜨겁게 달구어진 산처럼 강렬한 에너지를 품고 있어요.',
    personality:['강렬한 에너지와 카리스마','주도적이고 적극적인 성격','열정과 신념이 강함'],
    strengths:['강한 추진력과 실행력','리더십이 뛰어나요','어떤 도전도 두려워하지 않아요'],
    weaknesses:['과열되면 주변과 충돌할 수 있어요','감정 조절이 필요해요','독단적인 결정을 내릴 수 있어요'],
    career:['사업가·경영자','정치·리더직','군·경찰·소방'],
    relationship:'자신을 이해해주는 강한 파트너가 필요해요.',
    wealth:'사업적 직감이 뛰어나 큰 재물을 만들 수 있어요.',
    health:'심장과 혈압에 주의하세요.',
    advice:'뜨거운 마음에 지혜의 물을 더하면 완벽해요.',
  },
  '戊申': {
    stem:'戊', branch:'申',
    title:'광산(鑛山) — 금속을 품은 산',
    summary:'보물을 품은 광산처럼 내면에 풍부한 자원을 지니고 있어요. 실용적이고 능력 있는 기질이에요.',
    personality:['실용적이고 능력 중심적인 성격','냉철한 판단력과 분석력','현실 감각이 뛰어남'],
    strengths:['다양한 재능과 자원을 효율적으로 활용해요','목표 지향적이고 성과를 내요','문제 해결 능력이 뛰어나요'],
    weaknesses:['너무 실리적이어서 감정 교류가 부족해요','자기 이익을 앞세울 수 있어요','완벽한 조건만 찾다가 기회를 놓쳐요'],
    career:['광업·채굴·자원 관련','금융·투자','IT·엔지니어링'],
    relationship:'실용적이고 능력 있는 파트너를 원해요.',
    wealth:'자원을 효율적으로 활용해 부를 쌓아요.',
    health:'호흡기와 대장에 주의하세요.',
    advice:'풍부한 재능을 세상과 나눠보세요.',
  },
  '戊戌': {
    stem:'戊', branch:'戌',
    title:'준산(峻山) — 험준한 가을 산',
    summary:'험준하고 웅장한 산처럼 강한 의지와 넓은 포용력을 가지고 있어요.',
    personality:['의지가 강하고 원칙적인 성품','책임감과 의리가 두터움','자존심이 강하고 독립심이 뛰어남'],
    strengths:['어떤 상황도 굳건히 버텨내요','신뢰와 의리로 인망을 얻어요','넓은 포용력으로 사람을 품어요'],
    weaknesses:['고집이 세어 타협이 어려워요','자존심 때문에 도움을 거부해요','융통성이 부족해요'],
    career:['공무원·군·경찰','대기업·관리직','건설·부동산'],
    relationship:'자신을 존중해주는 파트너를 원해요.',
    wealth:'안정적 직업과 꾸준한 저축으로 자산을 쌓아요.',
    health:'위장과 관절에 주의하세요.',
    advice:'산은 혼자 서 있지만 많은 것을 품어요. 당신도 그래요.',
  },

  // ────── 己(기) 일간 ──────
  '己丑': {
    stem:'己', branch:'丑',
    title:'비절토(比節土) — 비온 뒤 단단해지는 땅',
    summary:'비를 맞아 더욱 단단해진 땅의 기운. 인내심이 강하고 어떤 어려움도 견뎌내요.',
    personality:['끈기와 인내심이 대단함','신중하고 보수적인 성격','내면이 단단하고 의지가 강함'],
    strengths:['어떤 고난도 이겨내는 힘','경제관념이 뛰어남','신뢰할 수 있는 동반자'],
    weaknesses:['융통성이 부족해요','과거에 집착할 수 있어요','변화를 받아들이기 어려워요'],
    career:['농업·축산·부동산','유통·도매·무역','공무원·회계사'],
    relationship:'든든한 파트너가 최고예요.',
    wealth:'꾸준히 모으면 부자가 될 수 있어요.',
    health:'위장과 관절에 주의하세요.',
    advice:'당신의 인내심은 큰 자산이에요.',
  },
  '己卯': {
    stem:'己', branch:'卯',
    title:'화원토(花園土) — 꽃밭의 기름진 땅',
    summary:'꽃을 풍성하게 피우는 기름진 땅의 기운. 포용력이 크고 주변을 아름답게 만드는 재주가 있어요.',
    personality:['포용력이 크고 온화한 성격','감수성이 풍부하고 예술적임','현실적이면서도 꿈을 가지고 있음'],
    strengths:['주변을 편안하고 아름답게 만들어요','인내심과 배려심이 깊어요','실용적인 창의성이 있어요'],
    weaknesses:['결단력이 부족할 수 있어요','우유부단한 면이 있어요','감정에 치우쳐 판단이 흐려질 수 있어요'],
    career:['예술·원예·인테리어','교육·보육·복지','요식업·서비스'],
    relationship:'따뜻하고 배려심 있는 파트너를 원해요.',
    wealth:'꾸준한 노력으로 안정적인 수입을 만들어요.',
    health:'소화기와 면역력에 주의하세요.',
    advice:'당신이 만든 아름다운 환경에서 당신도 행복하게 살아요.',
  },
  '己巳': {
    stem:'己', branch:'巳',
    title:'화전토(火田土) — 불로 다져진 땅',
    summary:'불의 기운을 받아 더욱 단단해진 땅의 기운. 영리하고 실행력이 강하며 성과 지향적이에요.',
    personality:['영리하고 실용적인 성격','성과 지향적이고 추진력 있음','사교적이고 적응력이 강함'],
    strengths:['목표 달성 능력이 뛰어나요','다양한 상황에 빠르게 적응해요','현실적인 아이디어를 잘 실현해요'],
    weaknesses:['이익을 지나치게 중시할 수 있어요','과정보다 결과에 집착해요','충동적 결정을 할 수 있어요'],
    career:['사업·마케팅','부동산·유통','컨설팅·영업'],
    relationship:'비슷한 가치관을 가진 현실적인 파트너를 원해요.',
    wealth:'사업 감각이 뛰어나 재물운이 좋아요.',
    health:'심장과 소화기에 주의하세요.',
    advice:'결과도 중요하지만 과정의 즐거움도 놓치지 마세요.',
  },
  '己未': {
    stem:'己', branch:'未',
    title:'옥토(沃土) — 여름 비에 촉촉해진 기름진 땅',
    summary:'풍요로운 수확을 약속하는 기름진 땅의 기운. 포용력이 넓고 주변을 편안하게 해주는 사람이에요.',
    personality:['포용력이 넓고 따뜻한 성품','예술적 감성과 현실 감각을 겸비함','누구와도 잘 어울리는 친화력'],
    strengths:['따뜻한 배려로 신뢰를 얻어요','다양한 사람을 품는 포용력','꾸준히 노력하는 성실함'],
    weaknesses:['자신보다 타인을 우선해 소진될 수 있어요','우유부단해질 수 있어요','감정에 치우치기 쉬워요'],
    career:['복지·사회서비스','교육·상담','농업·식품'],
    relationship:'누구와도 잘 지내지만 정작 자신에게 잘 맞는 사람을 찾는 데 시간이 걸려요.',
    wealth:'안정적 저축과 소소한 재테크가 잘 맞아요.',
    health:'소화기와 관절에 주의하세요.',
    advice:'당신의 풍요로움을 나눠줄수록 더 많이 돌아와요.',
  },
  '己酉': {
    stem:'己', branch:'酉',
    title:'청전토(淸田土) — 가을 수확의 땅',
    summary:'풍성한 수확을 맞이하는 가을 들판의 기운. 꼼꼼하고 성실하며 완성도를 중요시해요.',
    personality:['꼼꼼하고 완벽을 추구하는 성격','현실적이고 실용적임','전통과 원칙을 중시함'],
    strengths:['높은 완성도와 꼼꼼한 업무 처리','경제 감각이 뛰어나요','신뢰를 주는 안정적인 이미지'],
    weaknesses:['지나치게 완벽을 요구해요','변화에 적응이 느릴 수 있어요','보수적인 사고로 기회를 놓칠 수 있어요'],
    career:['세무·회계·법무','품질 관리·검수','공무원·금융'],
    relationship:'신뢰할 수 있고 안정적인 파트너를 원해요.',
    wealth:'꾸준한 저축으로 단단한 자산을 쌓아요.',
    health:'폐와 대장에 주의하세요.',
    advice:'완벽보다 완성이 중요해요. 때로는 80%로도 충분해요.',
  },
  '己亥': {
    stem:'己', branch:'亥',
    title:'전답수(田畓水) — 논에 가득 찬 물',
    summary:'논에 물이 가득 찬 모습처럼 풍요롭고 생산적인 기운. 지혜롭고 포용력이 있어요.',
    personality:['지혜롭고 직관력이 강함','포용력이 넓고 수용적인 성격','깊은 내면의 사색을 즐김'],
    strengths:['지혜로운 판단력과 직관','풍부한 감수성으로 공감 능력이 높아요','꾸준하고 안정적인 노력'],
    weaknesses:['우유부단할 수 있어요','너무 많이 수용하다가 지칠 수 있어요','현실 행동력이 부족할 수 있어요'],
    career:['상담·심리치료','교육·연구','무역·유통'],
    relationship:'깊은 교감이 가능한 따뜻한 파트너를 원해요.',
    wealth:'꾸준히 모으면 안정적인 자산이 형성돼요.',
    health:'신장과 소화기에 주의하세요.',
    advice:'당신의 지혜로운 판단을 더 믿어보세요.',
  },

  // ────── 庚(경) 일간 ──────
  '庚子': {
    stem:'庚', branch:'子',
    title:'검수금(劍水金) — 차가운 물에 담긴 검',
    summary:'차가운 물에 담긴 예리한 검처럼 냉철한 판단력과 강인함을 지니고 있어요.',
    personality:['냉철하고 분석적인 사고','강인한 의지와 결단력','원칙을 중시하는 성격'],
    strengths:['논리적이고 명쾌한 판단력','어떤 어려움도 돌파하는 강인함','목표를 향한 집중력'],
    weaknesses:['차갑게 느껴져 인간관계가 어려울 수 있어요','감정 표현이 부족해요','너무 직접적이어서 상처를 줄 수 있어요'],
    career:['법조·의학·공학','금융·분석직','연구·개발'],
    relationship:'냉철해 보이지만 속으로는 따뜻해요. 감정 표현 연습이 필요해요.',
    wealth:'분석적 투자로 안정적 수익을 만들어요.',
    health:'신장과 방광에 주의하세요.',
    advice:'차가운 외면 뒤에 따뜻한 마음이 있다는 걸 표현해보세요.',
  },
  '庚寅': {
    stem:'庚', branch:'寅',
    title:'도산금(刀山金) — 산을 베는 도끼',
    summary:'큰 산도 베어낼 것 같은 강인한 도끼의 기운. 강한 의지로 어떤 장애물도 넘어서요.',
    personality:['강인하고 도전적인 성격','추진력과 행동력이 강함','승부욕과 경쟁심이 강함'],
    strengths:['어떤 도전도 두려워하지 않아요','강한 리더십과 결단력','목표를 반드시 달성해요'],
    weaknesses:['충돌을 자주 일으킬 수 있어요','인내심이 부족할 때가 있어요','주변을 배려하는 것이 서툴러요'],
    career:['창업·사업가','군·경찰·소방','스포츠·체육'],
    relationship:'강한 상대에게 끌리지만 충돌도 많아요.',
    wealth:'적극적인 사업 활동으로 큰 수익을 낼 수 있어요.',
    health:'간과 근육에 주의하세요.',
    advice:'강함은 아름다운 거예요. 부드러움도 함께 키워보세요.',
  },
  '庚辰': {
    stem:'庚', branch:'辰',
    title:'탁산금(卓山金) — 산에서 캐낸 원광석',
    summary:'광산에서 막 캐낸 광석처럼 아직 다듬어지지 않은 강한 잠재력을 지니고 있어요.',
    personality:['잠재력이 크고 적응력이 강함','현실적이고 실용적인 성격','강한 자아와 추진력'],
    strengths:['숨겨진 능력이 점점 발현되는 성장형','강인한 실행력','포용력과 리더십을 갖추고 있어요'],
    weaknesses:['자만심이 생길 수 있어요','감정 처리가 어색해요','고집스럽게 느껴질 수 있어요'],
    career:['제조·기술·공학','사업가·기업인','부동산·건설'],
    relationship:'자신을 인정해주는 파트너를 원해요.',
    wealth:'꾸준히 갈고 닦으면 큰 재물을 만들어요.',
    health:'소화기와 관절에 주의하세요.',
    advice:'원석도 다듬으면 보석이 돼요. 계속 성장하세요.',
  },
  '庚午': {
    stem:'庚', branch:'午',
    title:'극화금(克火金) — 불 속에서 단련된 검',
    summary:'불속에서 단련된 검처럼 강인하고 빛나는 기운. 어떤 시련도 더욱 강하게 만들어요.',
    personality:['강하고 빛나는 카리스마','시련을 통해 강해지는 성격','결단력과 자신감이 넘침'],
    strengths:['어떤 역경도 성장의 발판으로 삼아요','카리스마 있는 리더십','강한 추진력과 실행력'],
    weaknesses:['너무 강해 주변을 압도할 수 있어요','자존심이 강해 타협이 어려워요','과열될 수 있어요'],
    career:['CEO·경영자','군·경찰·법조','운동선수·코치'],
    relationship:'동등한 파트너십을 원해요.',
    wealth:'도전적인 사업이나 투자에서 큰 성과를 낼 수 있어요.',
    health:'심장과 혈압에 주의하세요.',
    advice:'단련될수록 빛나는 게 바로 당신이에요.',
  },
  '庚申': {
    stem:'庚', branch:'申',
    title:'석하금(石榴金) — 단단하고 날카로운 보석',
    summary:'석류 속 알갱이처럼 단단하고 반짝이는 금의 기운. 추진력과 결단력이 강해요.',
    personality:['의리 있고 결단력이 강함','정의감이 강하고 솔직함','승부욕이 강하고 경쟁을 즐김'],
    strengths:['목표를 향해 돌진하는 힘','어려움을 즐기는 강인함','리더십과 추진력'],
    weaknesses:['날카로워 주변을 다칠 수 있어요','고집이 세고 융통성이 부족해요','쉽게 지치고 번아웃이 올 수 있어요'],
    career:['법조·경찰·군인','외과의사·치과의사','금융·투자·기업인'],
    relationship:'자신을 있는 그대로 받아주는 파트너가 좋아요.',
    wealth:'큰돈을 벌 수 있는 운이에요. 위험한 투자는 신중하게 하세요.',
    health:'호흡기와 폐에 주의하세요.',
    advice:'당신의 강인함은 멋져요. 가끔은 부드러워져도 괜찮아요.',
  },
  '庚戌': {
    stem:'庚', branch:'戌',
    title:'고금(庫金) — 창고에 쌓인 강인한 금속',
    summary:'단단하게 쌓인 금속의 기운. 축적된 힘과 지식으로 때를 기다렸다가 폭발적으로 발휘해요.',
    personality:['신중하고 때를 기다리는 성격','강한 의지와 보수적인 기질','책임감과 의리가 강함'],
    strengths:['준비된 사람의 철저한 실행력','강한 인내와 의지력','신뢰감 높은 안정적인 성격'],
    weaknesses:['때를 너무 오래 기다려 기회를 놓칠 수 있어요','보수적이어서 새로운 것에 소극적이에요','고집스럽게 느껴질 수 있어요'],
    career:['금융·보험·자산관리','법조·공무원','제조·기술직'],
    relationship:'안정적이고 신뢰할 수 있는 파트너를 원해요.',
    wealth:'꾸준한 저축과 신중한 투자로 큰 자산을 쌓아요.',
    health:'폐와 대장, 관절에 주의하세요.',
    advice:'기다림도 전략이에요. 하지만 영원히 기다리면 아무것도 안 돼요.',
  },

  // ────── 辛(신) 일간 ──────
  '辛丑': {
    stem:'辛', branch:'丑',
    title:'동토금(凍土金) — 얼어붙은 땅속의 보석',
    summary:'차가운 땅속에 묻혀 있는 보석처럼 겉으로는 드러나지 않지만 내면에 빛나는 재능을 품고 있어요.',
    personality:['내향적이지만 내면이 빛나는 성격','꼼꼼하고 신중한 성품','자신만의 세계가 뚜렷함'],
    strengths:['세심하고 정밀한 능력','독특하고 깊이 있는 재능','꾸준한 노력으로 결과를 만들어요'],
    weaknesses:['표현이 부족해 재능이 묻힐 수 있어요','자존심이 강해 협력이 어려울 수 있어요','인내 후 폭발하는 경향이 있어요'],
    career:['예술·공예·보석 디자인','연구·개발','세무·회계'],
    relationship:'자신을 깊이 이해해주는 파트너를 원해요.',
    wealth:'전문 기술로 안정적 수입을 만들어요.',
    health:'소화기와 관절에 주의하세요.',
    advice:'당신의 빛은 반드시 세상에 드러날 거예요.',
  },
  '辛卯': {
    stem:'辛', branch:'卯',
    title:'춘금(春金) — 봄에 빛나는 보석',
    summary:'봄날 빛을 받아 반짝이는 보석처럼 섬세하고 아름다운 기운. 감수성과 재능이 풍부해요.',
    personality:['감수성이 풍부하고 예술적임','섬세하고 아름다움을 추구함','사교적이고 표현력이 좋음'],
    strengths:['아름다운 것을 만드는 탁월한 재능','따뜻한 감수성으로 사람을 끌어요','유연하고 창의적인 사고'],
    weaknesses:['자존심이 강해 인정을 받고 싶어해요','변덕스럽고 집중력이 흐트러질 수 있어요','비판에 민감해요'],
    career:['패션·미용·예술','방송·연예','교육·상담'],
    relationship:'감성적으로 맞는 파트너를 원해요.',
    wealth:'재능을 상품화하면 큰 수익이 나요.',
    health:'목과 눈에 주의하세요.',
    advice:'봄의 보석처럼 세상을 아름답게 만드는 당신이에요.',
  },
  '辛巳': {
    stem:'辛', branch:'巳',
    title:'주화금(珠火金) — 불속에서 빛나는 진주',
    summary:'불 속에서도 빛을 잃지 않는 진주처럼 어떤 시련에도 빛나는 기운. 총명하고 매력적이에요.',
    personality:['총명하고 매력적인 성격','시련 속에서 더 빛나는 기질','지적이고 논리적임'],
    strengths:['뛰어난 지적 능력과 통찰력','어떤 시련도 성장의 기회로 만들어요','독특한 매력으로 주목을 받아요'],
    weaknesses:['자만심이 생길 수 있어요','감정 표현이 어색해요','완벽주의로 스트레스를 받아요'],
    career:['연구·학계','법조·의료','IT·데이터'],
    relationship:'지적으로 대등한 파트너를 원해요.',
    wealth:'전문성으로 안정적인 고수익을 만들어요.',
    health:'심장과 눈에 주의하세요.',
    advice:'당신의 빛은 시련 속에서 더 강해져요.',
  },
  '辛未': {
    stem:'辛', branch:'未',
    title:'전원금(田園金) — 들판에 빛나는 금',
    summary:'넓은 들판에서 반짝이는 금처럼 자유롭고 아름다운 기운. 예술적 감수성과 포용력을 지녀요.',
    personality:['자유롭고 예술적인 기질','따뜻하고 포용력 있는 성품','섬세한 감수성'],
    strengths:['뛰어난 예술적 재능','따뜻한 배려심으로 사람을 모아요','창의적인 아이디어'],
    weaknesses:['결단력이 부족할 수 있어요','감정에 치우쳐 판단이 흐려질 수 있어요','자기 주장이 약해요'],
    career:['예술·음악·공예','교육·봉사','패션·인테리어'],
    relationship:'따뜻하고 자유로운 관계를 원해요.',
    wealth:'예술적 재능으로 꾸준한 수입을 만들어요.',
    health:'소화기와 폐에 주의하세요.',
    advice:'넓은 들판처럼 자유롭게 빛나세요.',
  },
  '辛酉': {
    stem:'辛', branch:'酉',
    title:'중백금(重白金) — 정교하고 아름다운 보석',
    summary:'정교하게 다듬어진 보석처럼 세련되고 완벽한 것을 추구하는 기운.',
    personality:['완벽주의자 성향','섬세하고 예민한 감수성','깔끔하고 정돈된 것을 좋아함'],
    strengths:['디테일과 정밀함의 대가','예술적 감각이 뛰어남','신뢰할 수 있는 전문가'],
    weaknesses:['너무 예민해 쉽게 상처받아요','완벽을 추구하다 지쳐요','비판에 약해요'],
    career:['보석·패션·디자인','예술·음악·미술','세무·회계·검사'],
    relationship:'세심하게 배려해주는 파트너가 좋아요.',
    wealth:'전문성을 살리면 큰돈을 벌 수 있어요.',
    health:'폐와 호흡기, 피부에 주의하세요.',
    advice:'완벽할 필요는 없어요. 지금의 당신도 충분히 아름다워요.',
  },
  '辛亥': {
    stem:'辛', branch:'亥',
    title:'수중금(水中金) — 물속에 잠긴 보석',
    summary:'깊은 물속에 잠긴 보석처럼 신비로운 내면과 깊은 감수성을 지니고 있어요.',
    personality:['신비롭고 내성적인 매력','직관력이 강하고 감수성이 풍부함','독특한 개성과 세계관'],
    strengths:['깊은 직관과 통찰력','독특한 매력으로 사람을 끌어요','섬세하고 정확한 감각'],
    weaknesses:['고독을 즐기다 외로워질 수 있어요','감정 기복이 있어요','타협을 어려워할 수 있어요'],
    career:['연구·탐구','예술·문학','심리·상담'],
    relationship:'영적으로 깊이 통하는 파트너를 원해요.',
    wealth:'독창적인 방법으로 수익을 창출해요.',
    health:'신장과 폐에 주의하세요.',
    advice:'물속의 보석처럼 깊은 곳에 있는 당신의 가치를 세상에 드러내보세요.',
  },

  // ────── 壬(임) 일간 ──────
  '壬子': {
    stem:'壬', branch:'子',
    title:'양인수(羊刃水) — 거침없이 흐르는 대하',
    summary:'거침없이 흐르는 큰 물의 기운. 자유롭고 개방적이며 변화를 즐겨요.',
    personality:['자유로운 영혼','개방적이고 사교적임','변화와 모험을 즐김'],
    strengths:['어디서든 적응하는 능력','창의적이고 유연한 사고','사람들과 잘 어울림'],
    weaknesses:['변덕스럽고 끈기가 부족해요','계획 없이 충동적으로 행동해요','책임감이 부족해 보일 수 있어요'],
    career:['무역·유통·운송','여행·관광·호텔','IT·스타트업·미디어'],
    relationship:'함께 모험할 수 있는 파트너가 좋아요.',
    wealth:'돈이 들어오는 대로 나가요. 저축 습관을 들이세요.',
    health:'신장과 방광, 귀에 주의하세요.',
    advice:'당신의 자유로움은 매력이에요. 하지만 때로는 멈춰서 주변을 돌아보세요.',
  },
  '壬寅': {
    stem:'壬', branch:'寅',
    title:'원류수(源流水) — 산속 샘에서 힘차게 솟는 물',
    summary:'산 속 깊은 곳에서 힘차게 솟아오르는 샘물의 기운. 에너지가 넘치고 생명력이 강해요.',
    personality:['활발하고 생명력이 넘치는 성격','도전적이고 진취적임','창의적이고 독립적인 기질'],
    strengths:['새로운 것을 두려워하지 않아요','강한 생명력과 회복력','창의적 문제 해결 능력'],
    weaknesses:['충동적이어서 뒤처리가 필요해요','집중력이 산만할 수 있어요','감정 기복이 있어요'],
    career:['탐험·모험업','창업·스타트업','스포츠·체육'],
    relationship:'활발하고 자유로운 파트너를 원해요.',
    wealth:'사업 활동으로 큰 수익을 기대할 수 있어요.',
    health:'간과 근육에 주의하세요.',
    advice:'솟아나는 에너지를 한 방향으로 집중하면 엄청난 결과를 만들어요.',
  },
  '壬辰': {
    stem:'壬', branch:'辰',
    title:'용수(龍水) — 용이 노니는 깊은 호수',
    summary:'용이 사는 신비로운 호수처럼 깊고 광활한 기운. 지혜와 포용력이 뛰어나요.',
    personality:['지혜롭고 포용력이 넓은 성격','신비로운 매력과 깊은 통찰','자유롭지만 책임감도 있음'],
    strengths:['깊은 통찰력과 지혜','광범위한 지식과 포용력','어떤 상황도 유연하게 대처해요'],
    weaknesses:['결단을 내리는 데 시간이 걸려요','너무 많은 것을 담으려 해 지칠 수 있어요','산만해질 수 있어요'],
    career:['연구·학계','외교·국제관계','IT·데이터 분석'],
    relationship:'지적으로 깊이 교류할 수 있는 파트너를 원해요.',
    wealth:'다양한 분야에서 수입을 만드는 재주가 있어요.',
    health:'소화기와 신장에 주의하세요.',
    advice:'깊은 지혜를 세상과 나누면 더 빛날 거예요.',
  },
  '壬午': {
    stem:'壬', branch:'午',
    title:'천화수(天火水) — 강렬한 햇볕을 반사하는 강',
    summary:'태양빛을 받아 강렬하게 반짝이는 강물의 기운. 열정과 지혜가 공존하는 매력을 지녀요.',
    personality:['열정과 지혜가 공존하는 성격','감성적이면서도 이성적임','활동적이고 표현력이 강함'],
    strengths:['다양한 능력을 조화롭게 발휘해요','열정적이면서도 냉철한 판단력','사람들에게 영감을 주는 존재'],
    weaknesses:['상반된 기질로 내적 갈등이 생겨요','감정 기복이 있어요','과도한 에너지 소비로 지칠 수 있어요'],
    career:['방송·미디어','교육·강연','사업가·마케터'],
    relationship:'지적이면서도 감성적인 파트너를 원해요.',
    wealth:'다양한 수입원을 만드는 재주가 있어요.',
    health:'심장과 신장에 주의하세요.',
    advice:'불과 물이 만나면 수증기가 되어 더 높이 올라가요.',
  },
  '壬申': {
    stem:'壬', branch:'申',
    title:'원천금수(源泉金水) — 바위 틈에서 솟는 맑은 샘',
    summary:'바위 틈 사이로 솟아나는 맑은 샘물의 기운. 명석하고 실용적이며 날카로운 통찰력을 지녀요.',
    personality:['명석하고 분석적인 두뇌','실용적이고 목표 지향적임','냉철한 판단력'],
    strengths:['뛰어난 분석·논리 능력','현실적이고 효율적인 문제 해결','빠른 학습 능력'],
    weaknesses:['너무 실용적이어서 감성이 부족해 보여요','차갑게 느껴질 수 있어요','경쟁심이 강해 마찰이 생겨요'],
    career:['IT·공학','금융·컨설팅','연구·분석'],
    relationship:'지적이고 실용적인 파트너를 원해요.',
    wealth:'분석적 투자와 사업으로 안정적 수익을 만들어요.',
    health:'호흡기와 신장에 주의하세요.',
    advice:'명석함에 따뜻함을 더하면 완벽한 리더가 돼요.',
  },
  '壬戌': {
    stem:'壬', branch:'戌',
    title:'고수(庫水) — 댐에 저장된 힘찬 물',
    summary:'댐에 저장된 엄청난 수량의 물처럼 넘치는 내면의 힘을 지니고 있어요.',
    personality:['강한 내면의 힘과 깊은 생각','신중하고 때를 기다리는 성격','의리가 강하고 책임감이 있음'],
    strengths:['때를 기다렸다가 힘을 발휘해요','신뢰감이 높고 의리 있어요','강한 인내력'],
    weaknesses:['너무 오래 참으면 폭발해요','보수적이어서 기회를 놓칠 수 있어요','감정 표현이 부족해요'],
    career:['금융·자산관리','공무원·공기업','연구·개발'],
    relationship:'안정적이고 깊은 관계를 원해요.',
    wealth:'신중한 투자로 단단한 자산을 쌓아요.',
    health:'신장과 위장에 주의하세요.',
    advice:'저장된 힘을 적절한 때 폭발적으로 써보세요.',
  },

  // ────── 癸(계) 일간 ──────
  '癸丑': {
    stem:'癸', branch:'丑',
    title:'동설수(凍雪水) — 겨울 땅에 내린 눈',
    summary:'겨울 땅을 덮은 눈처럼 조용하고 고요하지만 봄이 되면 온 세상을 적시는 기운. 인내와 포용력이에요.',
    personality:['조용하고 인내심이 강한 성격','깊은 내면의 세계를 가짐','포용력이 넓고 따뜻함'],
    strengths:['어떤 상황도 참고 견디는 인내력','포용력으로 주변을 녹여요','꾸준한 노력으로 결실을 맺어요'],
    weaknesses:['자신의 의견을 표현하는 것이 어려워요','너무 참아서 지칠 수 있어요','우유부단해질 수 있어요'],
    career:['교육·상담·복지','연구·학계','공무원·안정직'],
    relationship:'따뜻하고 이해심 있는 파트너를 원해요.',
    wealth:'꾸준한 저축으로 안정적인 자산을 형성해요.',
    health:'신장과 소화기에 주의하세요.',
    advice:'봄이 되면 모든 눈은 녹아 세상을 풍요롭게 만들어요.',
  },
  '癸卯': {
    stem:'癸', branch:'卯',
    title:'춘우수(春雨水) — 봄비',
    summary:'봄에 내리는 단비처럼 주변에 생명과 활력을 불어넣는 기운. 감수성과 창의력이 빛나요.',
    personality:['감수성이 풍부하고 창의적임','따뜻하고 친화적인 성격','섬세하고 예술적 기질'],
    strengths:['예술적·창의적 재능이 뛰어나요','주변에 활력을 불어넣어요','공감 능력이 높아요'],
    weaknesses:['감정에 쉽게 흔들려요','결단력이 부족할 수 있어요','비판에 민감해요'],
    career:['예술·문학·음악','교육·상담','디자인·미디어'],
    relationship:'감성적으로 깊이 통하는 파트너를 원해요.',
    wealth:'창의적 재능을 사업화하면 수익이 생겨요.',
    health:'목과 면역력에 주의하세요.',
    advice:'당신의 감수성이 세상에 봄비처럼 생기를 불어넣어요.',
  },
  '癸巳': {
    stem:'癸', branch:'巳',
    title:'화증수(火蒸水) — 뜨거운 불 위의 수증기',
    summary:'불 위에서 증발하는 수증기처럼 열정과 지혜가 뒤섞인 독특한 기운. 변화무쌍하고 창의적이에요.',
    personality:['창의적이고 변화를 즐기는 성격','영리하고 적응력이 강함','직관력과 열정이 공존함'],
    strengths:['빠른 상황 적응력','창의적 문제 해결 능력','다재다능한 재능'],
    weaknesses:['집중력이 분산될 수 있어요','충동적 결정을 할 수 있어요','감정 기복이 있어요'],
    career:['IT·기술직','미디어·방송','컨설팅·기획'],
    relationship:'다양한 매력을 가진 파트너에게 끌려요.',
    wealth:'다양한 분야에서 수입을 창출할 수 있어요.',
    health:'심장과 신장에 주의하세요.',
    advice:'뜨겁게 증발할수록 더 높이 올라가는 게 수증기예요. 당신도 그래요.',
  },
  '癸未': {
    stem:'癸', branch:'未',
    title:'토윤수(土潤水) — 흙을 적시는 빗물',
    summary:'메마른 땅을 촉촉하게 적시는 빗물의 기운. 포용력이 넓고 배려심이 깊으며 부드러운 매력이 있어요.',
    personality:['포용력이 넓고 따뜻한 성품','감성적이고 배려심이 깊음','예술적 감수성을 지님'],
    strengths:['주변을 편안하게 만드는 능력','깊은 공감 능력','부드럽지만 꾸준한 노력'],
    weaknesses:['자신을 희생하다 지칠 수 있어요','결단력이 부족해요','감정 기복이 있어요'],
    career:['상담·치유·복지','예술·음악','교육·서비스'],
    relationship:'따뜻하고 안정적인 관계를 원해요.',
    wealth:'꾸준한 노력으로 안정적인 자산을 만들어요.',
    health:'소화기와 관절에 주의하세요.',
    advice:'촉촉이 내리는 비처럼 꾸준히 주변을 풍요롭게 해요.',
  },
  '癸酉': {
    stem:'癸', branch:'酉',
    title:'정금수(淨金水) — 보석을 씻어내는 맑은 물',
    summary:'보석을 맑게 씻어내는 샘물처럼 순수하고 섬세한 기운. 예민한 감수성과 높은 심미안을 지녀요.',
    personality:['순수하고 섬세한 감수성','높은 미적 안목과 예술성','내성적이지만 깊은 내면'],
    strengths:['뛰어난 예술적 감각','세심하고 정확한 관찰력','깊이 있는 전문성'],
    weaknesses:['너무 예민해 상처받기 쉬워요','완벽주의로 스트레스를 받아요','자기 표현이 어려워요'],
    career:['예술·미술·음악','패션·뷰티','연구·전문직'],
    relationship:'자신을 섬세하게 이해해주는 파트너를 원해요.',
    wealth:'전문적인 예술적 재능으로 수익을 만들어요.',
    health:'폐와 신장에 주의하세요.',
    advice:'당신의 순수함이 세상을 빛나게 해요.',
  },
  '癸亥': {
    stem:'癸', branch:'亥',
    title:'대해수(大海水) — 깊고 넓은 바다',
    summary:'깊고 넓은 바다처럼 포용력이 크고 지혜로운 기운. 감수성이 풍부하고 이해심이 깊어요.',
    personality:['포용력이 크고 이해심이 깊음','감수성이 풍부하고 직관력이 뛰어남','신비로운 매력이 있음'],
    strengths:['사람들의 마음을 읽는 능력','창의적이고 예술적인 재능','위기 상황에서의 침착함'],
    weaknesses:['너무 감정적이고 우울해질 수 있어요','현실 감각이 부족할 수 있어요','경계심이 약해 이용당할 수 있어요'],
    career:['예술·문학·영화','상담·치유·종교','해양·수산·여행'],
    relationship:'깊은 감정적 교류가 가능한 파트너가 좋아요.',
    wealth:'예술적 재능으로 돈을 벌 수 있어요. 안정적인 수입원을 만들어야 해요.',
    health:'신장과 생식기, 면역력에 주의하세요.',
    advice:'당신의 깊이는 소중해요. 가끔은 수면 위로 올라와 햇살을 쬐어도 괜찮아요.',
  },
};

// 기본 해석 (데이터에 없는 조합용)
const DEFAULT_INTERPRETATION: DayPillarInterpretation = {
  stem:'', branch:'',
  title:'균형 잡힌 사주',
  summary:'오행의 균형이 어느 정도 맞춰진 사주예요. 강한 특색보다는 무난하고 안정적인 기운을 가지고 있어요.',
  personality:['균형 잡힌 성격','상황에 따라 유연하게 대처','극단적이지 않은 성향'],
  strengths:['안정적인 성격으로 주변에서 신뢰함','다양한 상황에 적응력이 좋음','무난하게 인생을 살아갈 수 있음'],
  weaknesses:['특별한 강점이 두드러지지 않을 수 있음','결정을 내릴 때 고민이 많음','평범함에 안주하려는 욕구가 생길 수 있음'],
  career:['일반 사무직·공무원','안정적인 대기업','전문직'],
  relationship:'성격이 무난해서 다양한 사람과 잘 지낼 수 있어요.',
  wealth:'꾸준히 모으면 안정적인 재산을 만들 수 있어요.',
  health:'전반적으로 건강하지만 규칙적인 생활 습관이 중요해요.',
  advice:'당신의 무난함은 큰 장점이에요. 때로는 특별한 도전을 즐겨보세요.',
};

export function getDayPillarInterpretation(stem: string, branch: string): DayPillarInterpretation {
  const key = `${stem}${branch}`;
  return INTERPRETATIONS[key] || DEFAULT_INTERPRETATION;
}

// 오행 분포 해석
export function getElementInterpretation(distribution: Record<string, number>): {
  dominant: string;
  lacking: string;
  advice: string;
} {
  const entries = Object.entries(distribution);
  const max = entries.reduce((a, b) => a[1] > b[1] ? a : b);
  const min = entries.reduce((a, b) => a[1] < b[1] ? a : b);

  const elementNames: Record<string, string> = {
    '목':'나무(木)', '화':'불(火)', '토':'흙(土)', '금':'쇠(金)', '수':'물(水)',
  };
  const elementAdvice: Record<string, string> = {
    '목':'목이 많으면 성장과 발전의 기운이 강해요. 하지만 너무 많으면 고집이 세질 수 있으니 유연함을 기르세요.',
    '화':'화가 많으면 열정과 에너지가 넘쳐요. 하지만 너무 많으면 충동적이 될 수 있으니 차분함을 기르세요.',
    '토':'토가 많으면 안정감과 신뢰감이 있어요. 하지만 너무 많으면 융통성이 떨어질 수 있으니 개방성을 기르세요.',
    '금':'금이 많으면 추진력과 결단력이 강해요. 하지만 너무 많으면 날카로워질 수 있으니 부드러움을 기르세요.',
    '수':'수가 많으면 지혜와 유연성이 있어요. 하지만 너무 많으면 우유부단해질 수 있으니 결단력을 기르세요.',
  };

  return {
    dominant: elementNames[max[0]],
    lacking: elementNames[min[0]],
    advice: elementAdvice[max[0]],
  };
}
